export default function flattenArtifactSilences(files) {
	return files.flatMap(
		(file) =>
			(file.silences &&
				file.silences.map(({ start, end }) => ({
					start: file.start + start,
					end: file.start + end,
				}))) ||
			[],
	);
}
